import React from "react";
import { Link } from 'react-router-dom'

const BtnEdit = ({ href = '', search = '', click = null }) => (
    <div>
        <div className="admin-btnedit">
            <Link to={{ pathname: href, search}} className="action-edit" onClick={click}>แก้ไข</Link>
        </div>
    </div>
)

export { BtnEdit }